// import axios from "axios";
// import { ACCESS_TOKEN } from "./API/access_token";
// import { Toast } from "vant";
// 获取钉钉授权码
function getAccessToken (callback) {
  if (process.env.NODE_ENV === 'production') {
    return new Promise(resolve => {
      window.dd.ready(function () {
        window.dd.runtime.permission.requestAuthCode({
          corpId: 'ding7a05491d2e914134', // 企业id
          onSuccess: function (info) {
            const code = info.code
            resolve(code)
          }
        })
      })
    })
  }

  if (process.env.NODE_ENV === 'development') {
    return new Promise(resolve => {
      const code = 'f1c16889f36c325eb4bf27daa7ced310'
      resolve(code)
    })
  }
}
export default getAccessToken
